import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import {
  CIL_POINTS_GUIDE_PATH,
  disclaimer,
  drawerMeta,
  drawerSections,
} from '../../content/cilPointsPublicContent';

const InfoCILPointsModal = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    size={{ base: 'full', md: 'lg' }}
    scrollBehavior="inside"
    isCentered
  >
    <ModalOverlay />
    <ModalContent
      borderRadius={{ base: 0, md: 'xl' }}
      maxH={{ base: '100dvh', md: '90vh' }}
      my={{ base: 0, md: 4 }}
    >
      <ModalHeader pb={2} borderBottomWidth="1px" borderColor="gray.100">
        <Heading size="md" pr={8}>
          {drawerMeta.title}
        </Heading>
        <Text fontSize="sm" color="gray.600" fontWeight="normal" mt={1}>
          {drawerMeta.subtitle}
        </Text>
      </ModalHeader>
      <ModalCloseButton top={3} />

      <ModalBody py={4}>
        <VStack align="stretch" spacing={5}>
          {drawerSections.map((section) => (
            <Box key={section.title}>
              <Text fontWeight="bold" color="gray.800" mb={1}>
                {section.title}
              </Text>
              <Text fontSize="sm" color="gray.600" lineHeight="tall">
                {section.body}
              </Text>
              {section.bullets?.length > 0 && (
                <List spacing={1} mt={2} fontSize="sm" color="gray.600">
                  {section.bullets.map((item) => (
                    <ListItem key={item} display="flex" alignItems="flex-start">
                      <ListIcon
                        as={CheckCircleIcon}
                        color="purple.500"
                        mt={0.5}
                        flexShrink={0}
                      />
                      {item}
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          ))}

          <Box
            p={4}
            bg="purple.50"
            borderRadius="lg"
            borderWidth="1px"
            borderColor="purple.200"
          >
            <Text fontWeight="bold" fontSize="sm" color="purple.800" mb={2}>
              {disclaimer.title}
            </Text>
            <Text fontSize="sm" color="purple.900" lineHeight="tall">
              {disclaimer.body}
            </Text>
          </Box>
        </VStack>
      </ModalBody>

      <ModalFooter
        borderTopWidth="1px"
        borderColor="gray.100"
        flexDirection="column"
        gap={2}
      >
        <Button
          as={RouterLink}
          to={CIL_POINTS_GUIDE_PATH}
          colorScheme="purple"
          w="full"
          onClick={onClose}
        >
          Scopri di più
        </Button>
        <Button variant="ghost" w="full" onClick={onClose}>
          Chiudi
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default InfoCILPointsModal;
